import type { FieldValidationResult } from '@/components/Patient/utils';

const DOSAGE_MIN_LENGTH = 50;
export const DOSAGE_MAX_LENGTH = 250;

export const DOSAGE_EMPTY_ERROR_MESSAGE = 'Please provide detailed dosage instructions.';
export const DOSAGE_LENGTH_ERROR_MESSAGE = `Dosage instructions must be at least ${DOSAGE_MIN_LENGTH} characters.`;
export const DOSAGE_MAX_LENGTH_ERROR_MESSAGE = `Dosage instructions must not exceed ${DOSAGE_MAX_LENGTH} characters. Shorten text to continue.`;
export const DOSAGE_MAX_LENGTH_ALERT_MESSAGE = `Dosage instructions cannot exceed more than ${DOSAGE_MAX_LENGTH} characters.`;

export const validateDosageLength = (dosage = ''): FieldValidationResult => {
  const normalizedDosage = dosage.trim();

  if (normalizedDosage.length === 0) {
    return {
      hasError: true,
      errorMessage: DOSAGE_EMPTY_ERROR_MESSAGE,
    };
  }

  if (normalizedDosage.length < DOSAGE_MIN_LENGTH) {
    return {
      hasError: true,
      errorMessage: DOSAGE_LENGTH_ERROR_MESSAGE,
    };
  }

  return { hasError: false };
};
